var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-logo-container"},[_c('router-link',{staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('logo',{class:['my-20 mx-10', { 'logo-collapse': _vm.collapse }],attrs:{"width":null,"height":"40px","isWhite":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }